import React from 'react';
import { ArrowUpRightIcon } from 'lucide-react';
import { links } from '../data/site';
export function About() {
  return <section id="about" className="bg-paper-soft border-b border-rule" data-id="element-10" data-mp="2ps9uranptkg3">
      <div className="max-w-content mx-auto px-6 lg:px-10 py-20 md:py-24" data-id="element-11" data-mp="2tskc1jgyjxa9">
        <div className="grid md:grid-cols-12 gap-10 md:gap-14 items-start" data-id="element-12" data-mp="2ys5dc0jlohq5">
          <div className="md:col-span-4 lg:col-span-3" data-id="element-13" data-mp="2yq2auh19gw4j">
            <img src={links.portrait} alt="Portrait of Craig Thomas" className="w-40 h-40 md:w-full md:h-auto aspect-square object-cover rounded-lg border border-rule" data-id="element-14" data-mp="33q6u2etk04yg" />
          </div>

          <div className="md:col-span-8 lg:col-span-9 md:max-w-2xl" data-id="element-15" data-mp="3dj5vixa5fpzh">
            <h2 className="font-serif text-3xl md:text-4xl leading-tight tracking-tight text-ink" data-id="element-16" data-mp="3hhd0kuv932uu">
              About Craig
            </h2>

            <div className="mt-6 space-y-5 text-lg leading-relaxed text-ink-soft" data-id="element-17" data-mp="3mfwo2zphsmpb">
              <p data-id="element-18" data-mp="3req1yt8oyfq0">
                I’ve spent my career stepping into complicated organizations and helping turn
                strategy into execution. My background spans business operations, international
                leadership, technology, government programs, and mission-driven organizations.
              </p>
              <p data-id="element-19" data-mp="27rfx3kp9znex">
                I’m drawn to situations where the path forward is unclear and the work matters. I
                bring calm, directness, and a willingness to get into the details—to understand
                the problem, make decisions, and help people follow through.
              </p>
              <p data-id="element-20" data-mp="2vp54sogf7ssx">
                Developing leaders is part of how I work. A successful engagement leaves people
                more capable, responsibilities clearer, and operations easier to run.
              </p>
              <p className="text-ink" data-id="element-21" data-mp="3o5xyc6pn4hgy">
                I build systems and develop leaders so the organization is stronger after I leave.
                I lead toward my own redundancy.
              </p>
            </div>

            <p className="mt-8 pl-5 border-l-2 border-clay font-serif text-xl md:text-[1.375rem] leading-snug text-ink" data-id="element-22" data-mp="6751qi8kvo83">
              A principle I return to often: make decisions that make the future easier.
            </p>

            <a href={links.linkedin} target="_blank" rel="noopener noreferrer" className="mt-8 inline-flex items-center gap-1.5 text-base text-ink-soft hover:text-clay border-b border-rule hover:border-clay pb-0.5 transition-colors duration-200" data-id="element-23" data-mp="3tgtorwflecx6">
              Connect on LinkedIn
              <ArrowUpRightIcon size={16} aria-hidden="true" data-id="element-24" data-mp="3aktugez56xaf" />
            </a>
          </div>
        </div>
      </div>
    </section>;
}